import { Conditional } from "../conditional-render/ConditionalRender";
import Translatable from "../translatable_text/Translatable";

const eventsData = [
  {
    date: "24 Nov 2025",
    title: "How young Saudi founder Ahmed Al-Malki is bridging AI and psychology",
    company: "NeuroVate Lab",
    description: "Saudi Arabia’s tech growth is opening opportunities for young innovators like 23-year-old Ahmed Al-Malki, founder of Minus Zero and lead researcher at NeuroVate Lab. His work bridges AI and human psychology, supporting advancements in education, talent development, and data-driven decision-making.",
    link: 'https://www.arabnews.com/node/2623669/saudi-arabia'
  },
  {
    date: "Oct 2025",
    title: "UC TECH - Strategic partnership",
    company: "Dall-In",
    description: "We are pleased to announce a strategic partnership with UC TECH. This partnership aims to unify efforts between both parties in business development and expansion within the local market to build strategic collaborations. This will contribute to enhancing the quality of employment and training, positively impacting the return on investment, and achieving higher efficiency in the national output."
  },
  {
    date: "Aug 2025",
    title: "Minux Zero Release",
    company: "Dall-IN",
    description: "Step into the future of career and education planning with our groundbreaking AI! Share a description of yourself, and get precise, personalized insights for your ideal major and career. Your journey to success starts here!",
    link: 'https://dall-in.com/minus-zero'
  },
  {
    date: "Sep 2025",
    title: "Frontend Training",
    company: "GCAD",
    description: "Comprehensive frontend development training program covering modern technologies and frameworks to build responsive and interactive web applications."
  },
  {
    date: "Sep 2025",
    title: "Backend Training",
    company: "GCAD",
    description: "Intensive backend development training focusing on server-side technologies, database management, API development, and cloud infrastructure."
  },
];


function Events() {
  return (
    <div className="resume section-padding bord-thin-top" data-scroll-index="2">
      <div className="sec-head mb-50 wow d-rotate">
        <h3>
          <Translatable>
            Latest
          </Translatable> {" "}
           <span className="fw-200"> <Translatable>News</Translatable></span>
        </h3>
      </div>
      <div>
        <div className="resume-clumn">
          {eventsData.slice(0, 3).map((event, index) => (
            <div 
              className={`${index < eventsData.length - 1 ? "items mb-40" : "items"}`} 
              key={index}
            >
              <h6 className="date fz-14">{event.date}</h6>
              <h5>
                <Translatable>{event.title}</Translatable>{" "}
                <span className="fw-200 ml-15">[ At {event.company} ]</span>
              </h5>
              <div className="flex flex-wrap">
                <div className="w-full md:w-10/12">
                  <span className="mt-15 fz-14">
                    <Translatable>{event.description}</Translatable>
                  </span>
                  <Conditional condition={!!event?.link}>
                    <div className="underline">
                      <a target="_blank"  href={event?.link}><Translatable>Click Event Link</Translatable></a>
                    </div>
                  </Conditional>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Events;